<div class="card mb-4">
    <div class="card-header">
        <h3>Configuración de Productos A Transformar</h3>
    </div>

    <div class="card-body">
        <div class="row mb-3">
            <div class="col col-md-5">
                <h6>Producto Origen</h6>

                <app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.productEntry"
                    [placeholder]="'Ingresa un producto entrada'" [filterElements]="filterProductsEntry"
                    [typeElements]="'product-order'" (inputMethod)="writeProductEntry($event.event)"
                    (changeStatus)="checkProductEntry($event.filterElement)" (getTitle)="
            $event.filterElement.title =
              $event.filterElement.code + ' - ' + $event.filterElement.name
          "></app-input-autocomplete>
            </div>

            <div class="col col-md-5">
                <h6>Producto Salida</h6>

                <app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.productOutput"
                    [placeholder]="'Ingresa un producto salida'" [filterElements]="filterProductsOutput"
                    [typeElements]="'product-order'" (inputMethod)="writeProductOutput($event.event)"
                    (changeStatus)="checkProductOutput($event.filterElement)" (getTitle)="
            $event.filterElement.title =
              $event.filterElement.code + ' - ' + $event.filterElement.name
          "></app-input-autocomplete>
            </div>

            <div class="col col-md-2">
                <h6>Factor</h6>
                <input type="number" placeholder="100" name="factor" id="factor"
								[(ngModel)]="factor" class="form-control">
            </div>
        </div>

        <div class="row justify-content-center" style="font-size: 3rem;">
            <div class="text-center">
                <ng-container *ngIf="(inputs.productEntry.data && inputs.productOutput.data); else noFactor">
                    <span class="text-muted">1</span>
                    <i class="fa-solid fa-arrow-right mx-2"></i>
                    <strong>{{factor | number:'1.0-4'}}</strong>
                </ng-container>

                <ng-template #noFactor>
                    <span class="text-muted"> - </span>
                </ng-template>

            </div>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-3">
            <button class="btn btn-outline-secondary" (click)="reset()">
                Limpiar
            </button>

            <button class="btn btn-success" [disabled]="!inputs.productEntry.data?.id || !inputs.productOutput.data?.id || !factor"
                (click)="saveConfig()">
                Guardar Configuracion
            </button>
        </div>
    </div>
</div>

<div class="card">
    <div class="card-header">
        <h3>Configuraciones</h3>
    </div>

    <div class="card-body">
        <div class="row">
            <div class="row mb-3 col col-md-6">
                <div class="table-responsive" style="margin-bottom: 0; overflow-y: inherit; max-height: none;">
                    <div>
                        <div class="row" id="options-other-filters">
                            <div class="col-sm form-group">
                                <label for="filterVendors" class="form-label">Filtrar</label>
                                <div class="input-group input-group-sm">
                                    <input
                                        type="text"
                                        id="filter"
                                        [(ngModel)]="filterWord"
                                        (input)="onInputChange($event)"
                                        placeholder="Filtra lista por nombre"
                                        name="filter"
                                        class="form-control"
                                    />
                                    <button class="btn btn-primary" (click)="searching()">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-hover table-responsive shadow" style="margin-bottom: 0; margin-top: 10px;">
                        <thead>
                            <tr class="tr-middle">
                                <th class="ta">
                                    Código
                                </th>
                                <th class="ta">
                                    Producto
                                </th>
                                <th class="ta text-center">
                                    Acción
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="tr-middle cursor-pointer px-2" *ngFor="let item of pagination.filter">
                                <td class="col" 
                                [class.bg-blue-50]="item.id==productSelectedId" [class.font-bold]="item.id==productSelectedId"
                                (click)="setProductConversion(item)">
                                    {{item.code}}
                                </td>
                                <td class="col" 
                                [class.bg-blue-50]="item.id==productSelectedId" [class.font-bold]="item.id==productSelectedId"
                                (click)="setProductConversion(item)">
                                    {{item.name}}
                                </td>
                                <td class="col" [class.bg-blue-50]="item.id==productSelectedId" [class.font-bold]="item.id==productSelectedId">
                                    <span class="clickeable text-danger a-hover" (click)="deleteAllProductConversion(item.id)">
                                        <i *ngIf="!deleting[item.id]" class="fa fa-trash"></i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <app-pagination-custom [elements]="pagination"></app-pagination-custom>
                </div>
            </div>
    
            <div class="row mb-3 col col-md-6">
                <div class="table-responsive" style="margin-bottom: 0; overflow-y: inherit; max-height: none;" *ngIf="productSelected">
                    <div>
                        <h6>Configuraciones de <strong>{{productSelected.code}} - {{productSelected.name}}</strong> </h6>
                    </div>
                    <!-- <div>
                        <div class="row" id="options-other-filters">
                            <div class="col-sm form-group">
                                <label for="filterVendors" class="form-label">Filtrar</label>
                                <div class="input-group input-group-sm">
                                    <input
                                        type="text"
                                        id="filter"
                                        [(ngModel)]="filterWord"
                                        (input)="onInputChange($event)"
                                        placeholder="Filtra lista por nombre"
                                        name="filter"
                                        class="form-control"
                                    />
                                    <button class="btn btn-primary" (click)="searching()">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <table class="table table-hover table-responsive shadow" style="margin-bottom: 0; margin-top: 10px;">
                        <thead>
                            <tr class="tr-middle">
                                <th class="ta">
                                    Código
                                </th>
                                <th class="ta">
                                    Producto
                                </th>
                                <th class="ta text-right">
                                    Factor
                                </th>
                                <th class="ta text-center">
                                    Acción
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="tr-middle cursor-pointer px-2" *ngFor="let item of targetProductsConversion">
                                <td class="col" >
                                    {{item.targetProduct.code}}
                                </td>
                                <td class="col">
                                    {{item.targetProduct.name}}
                                </td>
                                <td class="ta text-right factor-cell">
    
                                    <!-- Modo normal -->
                                    <div *ngIf="!editingFactorId[item.productConversion.id]"
                                        class="factor-display"
                                        (click)="startEditingFactor(item.productConversion)">
    
                                        <span class="factor-value">
                                            {{ item.factor | number:'1.2-4' }}
                                        </span>
    
                                        <i class="fa fa-edit edit-icon"></i>
                                    </div>
    
                                    <!-- Modo edición -->
                                    <div *ngIf="editingFactorId[item.productConversion.id]"
                                        class="factor-edit">
    
                                        <input
                                            type="number"
                                            class="form-control form-control-sm factor-input"
                                            [(ngModel)]="editingFactorValue"
                                            [disabled]="savingFactor"
                                            step="any"
                                            min="0"
                                            autofocus
                                            (keyup.enter)="saveFactor(item)"
                                            (keyup.escape)="cancelEditingFactor(item.productConversion)">
    
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-success"
                                            [disabled]="savingFactor"
                                            (click)="saveFactor(item)">
                                            <i class="fa fa-floppy-disk"></i>
                                        </button>
    
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-danger"
                                            [disabled]="savingFactor"
                                            (click)="cancelEditingFactor(item.productConversion)">
                                            <i class="fa fa-times"></i>
                                        </button>
    
                                        <!-- Loading solamente en este campo -->
                                        <i *ngIf="savingFactor"
                                        class="fa fa-spinner fa-spin factor-loading">
                                        </i>
                                    </div>
                                </td>
                                <td class="col">
                                    <span class="clickeable text-danger a-hover" (click)="deleteProductConversionById(item.productConversion.id)">
                                        <i *ngIf="!deleting[item.id]" class="fa fa-trash"></i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
